/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    IdeaSearch,
    IdeaSearchFromJSON,
    IdeaSearchToJSON,
    IdeaSearchAdminAllOf,
    IdeaSearchAdminAllOfFromJSON,
    IdeaSearchAdminAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdeaSearchAdmin
 */
export interface IdeaSearchAdmin {
    /**
     * 
     * @type {string}
     * @memberof IdeaSearchAdmin
     */
    sortBy?: IdeaSearchAdminSortByEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaSearchAdmin
     */
    filterCategoryIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IdeaSearchAdmin
     */
    invertCategory?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaSearchAdmin
     */
    filterStatusIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IdeaSearchAdmin
     */
    invertStatus?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaSearchAdmin
     */
    filterTagIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof IdeaSearchAdmin
     */
    invertTag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdeaSearchAdmin
     */
    filterAuthorId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdeaSearchAdmin
     */
    invertAuthorId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IdeaSearchAdmin
     */
    searchText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdeaSearchAdmin
     */
    fundedByMeAndActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IdeaSearchAdmin
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof IdeaSearchAdmin
     */
    similarToIdeaId?: string;
    /**
     * 
     * @type {Date}
     * @memberof IdeaSearchAdmin
     */
    filterCreatedStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IdeaSearchAdmin
     */
    filterCreatedEnd?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IdeaSearchAdmin
     */
    filterLastActivityStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IdeaSearchAdmin
     */
    filterLastActivityEnd?: Date;
}

export function IdeaSearchAdminFromJSON(json: any): IdeaSearchAdmin {
    return {
        'sortBy': !exists(json, 'sortBy') ? undefined : json['sortBy'],
        'filterCategoryIds': !exists(json, 'filterCategoryIds') ? undefined : json['filterCategoryIds'],
        'invertCategory': !exists(json, 'invertCategory') ? undefined : json['invertCategory'],
        'filterStatusIds': !exists(json, 'filterStatusIds') ? undefined : json['filterStatusIds'],
        'invertStatus': !exists(json, 'invertStatus') ? undefined : json['invertStatus'],
        'filterTagIds': !exists(json, 'filterTagIds') ? undefined : json['filterTagIds'],
        'invertTag': !exists(json, 'invertTag') ? undefined : json['invertTag'],
        'filterAuthorId': !exists(json, 'filterAuthorId') ? undefined : json['filterAuthorId'],
        'invertAuthorId': !exists(json, 'invertAuthorId') ? undefined : json['invertAuthorId'],
        'searchText': !exists(json, 'searchText') ? undefined : json['searchText'],
        'fundedByMeAndActive': !exists(json, 'fundedByMeAndActive') ? undefined : json['fundedByMeAndActive'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'similarToIdeaId': !exists(json, 'similarToIdeaId') ? undefined : json['similarToIdeaId'],
        'filterCreatedStart': !exists(json, 'filterCreatedStart') ? undefined : new Date(json['filterCreatedStart']),
        'filterCreatedEnd': !exists(json, 'filterCreatedEnd') ? undefined : new Date(json['filterCreatedEnd']),
        'filterLastActivityStart': !exists(json, 'filterLastActivityStart') ? undefined : new Date(json['filterLastActivityStart']),
        'filterLastActivityEnd': !exists(json, 'filterLastActivityEnd') ? undefined : new Date(json['filterLastActivityEnd']),
    };
}

export function IdeaSearchAdminToJSON(value?: IdeaSearchAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'sortBy': value.sortBy,
        'filterCategoryIds': value.filterCategoryIds,
        'invertCategory': value.invertCategory,
        'filterStatusIds': value.filterStatusIds,
        'invertStatus': value.invertStatus,
        'filterTagIds': value.filterTagIds,
        'invertTag': value.invertTag,
        'filterAuthorId': value.filterAuthorId,
        'invertAuthorId': value.invertAuthorId,
        'searchText': value.searchText,
        'fundedByMeAndActive': value.fundedByMeAndActive,
        'limit': value.limit,
        'similarToIdeaId': value.similarToIdeaId,
        'filterCreatedStart': value.filterCreatedStart === undefined ? undefined : value.filterCreatedStart.toISOString(),
        'filterCreatedEnd': value.filterCreatedEnd === undefined ? undefined : value.filterCreatedEnd.toISOString(),
        'filterLastActivityStart': value.filterLastActivityStart === undefined ? undefined : value.filterLastActivityStart.toISOString(),
        'filterLastActivityEnd': value.filterLastActivityEnd === undefined ? undefined : value.filterLastActivityEnd.toISOString(),
    };
}

/**
* @export
* @enum {string}
*/
export enum IdeaSearchAdminSortByEnum {
    Trending = 'Trending',
    Top = 'Top',
    New = 'New',
    Random = 'Random',
    DragAndDrop = 'DragAndDrop'
}


